import axios from 'axios'
import { config } from '../../config'
import { useUserStore } from '../../stores/user'
// import { useAuthStore } from '../../stores/auth-store'
// import router from '../../router'
// import { storeToRefs } from 'pinia'


const httpConfig = {
  baseURL: config.api.baseUrl, //'http://127.0.0.1:8000/api', //config.api.baseUrl
}
const httpClient = axios.create(httpConfig)
const authInterceptor = (config: any) => {
  // const authStore = storeToRefs(useAuthStore())\\
  const userStore = useUserStore()
  // if (authStore.token != null) {
  config.headers.Authorization = `Bearer ${userStore.getAccessToken()}`
  config.headers['Content-Type'] = `application/json`
  //config.headers['Content-Type'] = `application/x-www-form-urlencoded`
  // }
  return config
}

const loggerInterceptor = (config: any) => {
  /** Add logging here */
  return config
}

/** Adding the request interceptors */
httpClient.interceptors.request.use(authInterceptor)
httpClient.interceptors.request.use(loggerInterceptor)

/** Adding the response interceptors */
httpClient.interceptors.response.use(
  (response: any) => {
    if (response.status !== 200) {
      return null
    }
    return response
  },
  (error) => {
    // logService.error(error.response);
    if (error.response.status === 401) {
      // store.dispatch("raiseError", "Unauthorized");
      // store.dispatch("user/logout");
      // router.push({ path: "/" }); // redirect to login page if unauthorized. valid feature but not during development
    } else {
      // store.dispatch("raiseError", "Unexpected error happened");
    }
    return Promise.reject(error)
  },
)

export { httpClient }
